import { v4 as uuidv4 } from 'uuid';

export class Base {
	constructor() {
		this.uuid = uuidv4();		
	}

	toJSON() {
		return {
			uid: this.uid
		};
	}

	fromJSON( json ) {
		this.uid = json.uid;
	}

	_parseValue( value, from, to ) {
		if( value === undefined || value === null ) {
			switch( to ) {
				case 'string':
					return '';
				case 'number':
					return 0;
				case 'boolean':
					return false;
				default:
			}
		}

		if( from === 'string' && to === 'number' ) {
			if( typeof value === 'string' ) return parseFloat( value );
			if( typeof value === 'boolean' ) return value ? 1 : 0;
			if( typeof value === 'number' ) return value;
		}
		else if( from === 'string' && to === 'boolean' ) {
			if( typeof value === 'string' ) return value === 'VERDADERO' || value.toLowerCase() === 'true' ? true : false;
			if( typeof value === 'boolean' ) return value;
			if( typeof value === 'number' ) return value === 1;
		}
		else if( from === 'number' && to === 'string' ) {
			if( typeof value === 'string' ) return value;
			if( typeof value === 'boolean' ) return value ? '1' : '0';
			if( typeof value === 'number' ) return value.toString();
		}
		else {
			return value;
		}
	}
}